import ContactForm from '@/components/ContactForm'
import type { SectionOf } from './shared'

export default function FormSection({ section }: { section: SectionOf<'form'> }) {
  return (
    <div className="mx-auto flex max-w-3xl flex-col items-center gap-12" id="contact">
      {/*
        Bigger than a section heading anywhere else on the site, on purpose:
        this is the closing statement of the page. `sub` under it is the brand
        line, so it is set as a line and not as prose — brand indigo, tracked,
        no muted grey.
      */}
      <div className="text-center">
        <h2
          className={`text-4xl font-bold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl ${
            // `nowrap` from `sm` UP, never on a phone. The request it serves
            // (2026-09-08) is about the desktop line not breaking for
            // "OUTCOME." alone — at 390px this heading is 554px wide, so
            // honouring it there does not keep the line together, it pushes
            // the whole page 82px sideways and every section scrolls with it.
            section.headingNoWrap ? 'whitespace-normal sm:whitespace-nowrap' : ''
          }`}
        >
          {section.heading}
        </h2>
        {section.sub && (
          <p className="mt-6 text-2xl font-bold tracking-[0.08em] text-primary sm:text-3xl">
            {section.sub}
          </p>
        )}
      </div>
      <div className="w-full">
        {/*
          The fields live in `components/ContactForm.tsx`, because Contact Us
          carries the same form and a second copy of them would drift — the
          framed box around them is in there too, for the same reason. Still
          fields and labels only: there is no submit endpoint, and the check
          on this section is what keeps that from being forgotten.
        */}
        <ContactForm
          fields={section.fields}
          consent={section.consent}
          submit={section.submit}
          confirmation={section.confirmation}
          privacy={section.privacy}
          thanks={section.thanks}
        />
      </div>
    </div>
  )
}
